"use client";

import { useEffect } from "react";
import markerSDK from "@marker.io/browser";

export const MarkerIo = () => {
  const markerIoProject = process.env.NEXT_PUBLIC_MARKER_IO_PROJECT;

  useEffect(() => {
    if (!markerIoProject) return;

    async function initMarkerWidget() {
      try {
        await markerSDK.loadWidget({
          project: markerIoProject!,
        });
      } catch (error) {
        console.error("Failed to load Marker.io widget:", error);
      }
    }

    initMarkerWidget();
  }, [markerIoProject]);

  return null;
};
